import {
  all,
  takeEvery,
  fork,
  put,
  select,
  take,
  cancel
} from "redux-saga/effects";

import * as R from "ramda";

// import { apiCall } from "App/Data/sagas";

import { actions, getters } from "./model";

import { SEARCH_BAR_INSTANCE_ID_CALENDAR_HOME_SECTION } from "./constants";

import { actions as SearchBarActions } from "ui-kit/SearchBar";

const init = function*() {
  // load details
  const { payload } = {
    payload: {
      "August 2023": [
        {
          date: "Wednesday, august 9",
          events: [
            {
              time: "12:00am",
              timezone: "CST",
              description: "Submit passport",
              eventId: 123,
              eventName: "Base Event",
              status: "not_submitted",
              type: "task"
            }
          ]
        },
        {
          date: "Saturday, august 12",
          events: [
            {
              time: "3:00pm",
              timezone: "CST",
              description: "Team meeting",
              eventId: 456,
              eventName: "Team meeting",
              status: "not_submitted",
              type: "task"
            },
            {
              time: "6:00pm - 8:00pm",
              timezone: "CST",
              location: "Conference Room",
              description: "Networking event",
              eventId: 789,
              eventName: "Other event",
              type: "event"
            }
          ]
        }
      ],
      "September 2024": [
        {
          date: "Friday, September 1",
          events: [
            {
              time: "9:00am",
              timezone: "CST",
              description: "Meeting",
              eventId: 456,
              eventName: "Meeting",
              status: "not_submitted",
              type: "task"
            }
          ]
        },
        {
          date: "Friday, September 15",
          events: [
            {
              time: "2:00pm - 4:00pm",
              timezone: "CST",
              location: "Room ABC",
              description: "Workshop",
              eventId: 789,
              eventName: "Workshop",
              type: "event"
            }
          ]
        },
        {
          date: "Saturday, September 30",
          events: [
            {
              time: "10:00am",
              timezone: "CST",
              description: "Deadline for project submission",
              eventId: 123,
              eventName: "Deadline for project submission",
              status: "not_submitted",
              type: "task"
            }
          ]
        }
      ],
      "October 2024": [
        {
          date: "Thursday, October 5",
          events: [
            {
              time: "10:00am",
              timezone: "CST",
              description: "Submit Headshot",
              eventId: 123,
              eventName: "Submit Headshot",
              status: "Completed",
              type: "task"
            }
          ]
        },
        {
          date: "Friday, October 20",
          events: [
            {
              time: "6:00pm - 7:00pm",
              timezone: "CST",
              location: "Room BABC",
              description: "Faculty Career Partners by Organic Design",
              eventId: 123,
              eventName: "Faculty Career Partners by Organic Design",
              type: "event"
            }
          ]
        },
        {
          date: "Tuesday, October 31",
          events: [
            {
              time: "8:00pm",
              timezone: "CST",
              description: "Halloween Party",
              eventId: 456,
              eventName: "Halloween Party",
              type: "event"
            }
          ]
        }
      ]
    }
  };

  yield put(
    actions.setInitialData({
      ...payload
    })
  );
};

const search = function*() {
  const originalEvents = yield select(getters.originalData);
  yield put(actions.setData(originalEvents));
};

const watchSearch = function*() {
  let searchTask;
  for (;;) {
    const action = yield take([
      SearchBarActions.clearSearch.type,
      SearchBarActions.setSearchTerm.type
    ]);

    if (searchTask) {
      yield cancel(searchTask);
    }
    if (action.type === SearchBarActions.setSearchTerm.type) {
      if (
        R.path(["meta", "instanceId"], action) ===
        SEARCH_BAR_INSTANCE_ID_CALENDAR_HOME_SECTION
      ) {
        searchTask = yield fork(search, action);
      }
    } else if (action.type === SearchBarActions.clearSearch.type) {
      if (
        R.path(["meta", "instanceId"], action) ===
        SEARCH_BAR_INSTANCE_ID_CALENDAR_HOME_SECTION
      ) {
        searchTask = yield fork(search, action);
      }
    }
  }
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const rootSaga = function*() {
  yield all([fork(watchInit), fork(watchSearch)]);
};

export default rootSaga;
